import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TipoSangue } from '../model/TipoSangue';

@Injectable({
  providedIn: 'root'
})
export class CarteirinhaService {

  urlCarteirinha= '';

  constructor(private httpClient: HttpClient) {
    this.urlCarteirinha = `${environment.apiUrl}/carteiras/carteira-socio-dependente`;
  }

  buscarDadosCarteirinha(
    idSocio: any,
    idEmpresa: any,
    tipoSocio: any,
    token: any
  ){
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })}
      return this.httpClient.get(`${this.urlCarteirinha}/${idSocio}/${idEmpresa}/${tipoSocio}`, httpHeaders)
  }


}
